import { useMemo } from 'react';
import { CopilotOutput } from 'libs/end-to-end/src/copilot';
import { CustomVizHookResult } from 'apps/sigma2-ui/src/lib/custom-viz/types';
import { CustomVizHookStatus } from 'apps/sigma2-ui/src/lib/custom-viz/types';
import { BasicCopilotOutputState } from 'apps/sigma2-ui/src/copilot/types/BasicCopilotOutputState';

export const useBasicCopilotCurrentState = ({
  result,
  status,
}: {
  result: CustomVizHookResult;
  status: CustomVizHookStatus;
}) => {
  return useMemo<BasicCopilotOutputState>(() => {
    if (result.resultType === 'err') {
      return {
        state: 'error_state',
      };
    }

    if (status === 'loading-viz') {
      return {
        state: 'loading_state',
      };
    }

    if (result.value === null) {
      return {
        state: 'empty_state',
      };
    }

    const parseResult = CopilotOutput.safeParse(result.value);
    if (parseResult.success) {
      return {
        state: 'success',
        output: parseResult.data,
      };
    } else {
      return {
        state: 'error_state',
      };
    }
  }, [result, status]);
};
